var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-wrap"},[_c('div',{staticClass:"flex-page"}),(_vm.showLoading)?_c('i-loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }